<template>
    <div class="footer d-flex flex-row justify-content-around">
        <div class="a_propos d-flex flex-column">
            <h2>A Propos</h2>
            <router-link class="is-tab nav-item" to="/">Mentions légales</router-link>
            <router-link class="is-tab nav-item" to="/">RGPD</router-link>
            <router-link class="is-tab nav-item" to="/">Plan du site</router-link>
        </div>
        <div class="contact d-flex flex-column">
            <h2>Contact</h2>
            <a href="mailto:developpement@nathan-rousseau.fr">Me contacter</a>
            <a href="https://www.linkedin.com/in/nathan-rousseau-602a30171/" target="_blank" rel="noreferrer">LinkedIn</a>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

    .footer {
        width: 100%;
        background-color: #363636;
    }

    .a_propos{
        border-left: 3px solid #EAEAEA ;
        padding-left: 10px;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .contact{
        border-left: 3px solid #EAEAEA ;
        padding-left: 10px;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    h2{
        font-size: 12px;
        font-weight: bold;
        color: #EAEAEA;
        margin-bottom: 5px;
    }

    a {
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 5px;
    }

    @media (min-width: 576px) {
        h2{
            font-size: 16px;
            margin-bottom: 5px;
        }

        a {
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
    @media (min-width: 768px) {
        h2{
            font-size: 18px;
            margin-bottom: 10px;
        }

        a {
            font-size: 18px;
            margin-bottom: 10px;
        }
    }
    @media (min-width: 992px) {

    }
    @media (min-width: 1200px) {

    }
    @media (min-width: 1600px) {

    }

</style>